<template>
  <callout
    :border-color="`primary-${value.isActive ? '7' : '6'}`"
    class="mb-3"
    :has-toggle="false"
  >
    <div class="row">
      <div class="col-sm border-right border-right--variant cell">
        <span class="data-name">Nombre:</span>
        <p class="data">{{ value.name }}</p>
      </div>
      <div class="col-12 d-none d-md-none d-sm-block">
        <hr />
      </div>
      <div class="col-sm cell">
        <span class="data-name">Tipo:</span>
        <p class="data">{{ value.practitionerTypes }}</p>
      </div>
      <div class="col-sm-12 col-md-2 cell mt-3 mt-md-0">
        <span class="data-name">Estatus:</span>
        <div class="w-70 d-flex align-items-center">
          <em
            class="fas fa-circle"
            :class="`color-primary-${value.isActive ? '7' : '6'}`"
          />
          <span class="font-weight-normal color-black ml-2">
            {{ value.isActive ? 'Activo' : 'Inactivo' }}
          </span>
        </div>
      </div>
      <div class="col-sm-12 col-md-4 cell mt-3 mt-md-0">
        <span class="data-name">Especialidad:</span>
        <p class="data">
          {{ value.specialties }}
        </p>
      </div>
      <div
        class="col d-flex align-items-center justify-content-md-end justify-content-sm-start mr-0 mr-md-4 mr-sm-0 cell mt-3 mt-md-0"
      >
        <div class="w-sm-100 w-md-70">
          <action-button
            class="w-100"
            i="fas fa-file-import"
            text="Entrar"
            variant="outline-success"
            @click="enterHandler"
          />
        </div>
      </div>
    </div>
  </callout>
</template>

<script>
import Callout from 'custom-callout';
import ActionButton from 'ActionButton';
import alertMixin from 'utils/mixins/alert.mixin';

const PRACTITIONER_INTERN_ADD = 'PractitionerInternAdd';
const PRACTITIONER_INTERN_EDIT = 'PractitionerInternEdit';

export default {
  name: 'AvailableSpaceRow',
  components: {
    Callout,
    ActionButton,
  },
  mixins: [alertMixin],
  props: {
    value: {
      type: Object,
      default: () => {
        return {
          id: null,
          name: null,
          practitionerTypeId: null,
          practitionerType: null,
          isActive: null,
          specialties: null,
          companyId: null,
        };
      },
    },
    selectedAcademicYear: {
      type: Number,
      default: () => {},
    },
  },
  data() {
    return {};
  },
  methods: {
    addHandler() {
      this.$router.push({
        name: PRACTITIONER_INTERN_ADD,
      });
    },
    enterHandler() {
      const practitionerId = this.value.id;
      const fiscalYearId = this.selectedAcademicYear;
      const companyId = this.value.companyId;

      if (practitionerId) {
        this.$router.push({
          name: PRACTITIONER_INTERN_EDIT,
          params: {
            practitionerId,
            companyId,
            fiscalYearId,
          },
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
p.data {
  margin-bottom: 0px !important;
}
.row .cell {
  padding-top: 5px !important;
}

@media only screen and (max-width: 768px) {
  .border-right--variant {
    border-right: unset !important;
  }
}
</style>
